var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col"},[_c('Box',{staticClass:"sec-2",attrs:{"code":"sec2","data":_vm.data},on:{"reload":_vm.reload}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }